export const permission = {
  MYMEDAX_QUESTIONNAIRE_CREATE: 'MYMEDAX_QUESTIONNAIRE_CREATE',
  MYMEDAX_QUESTIONNAIRE_READ: 'MYMEDAX_QUESTIONNAIRE_READ',
  MYMEDAX_QUESTIONNAIRE_UPDATE: 'MYMEDAX_QUESTIONNAIRE_UPDATE',
  MYMEDAX_QUESTIONNAIRE_DELETE: 'MYMEDAX_QUESTIONNAIRE_DELETE'
};
